import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { selectImportedFinalUsers, selectImportingFinalUsers } from 'src/app/store/user-file/user-file.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FinalUsersList } from 'src/app/model/final-users-list';
import { selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import { User } from 'src/app/model/user';


@Component({
	templateUrl: './import-final-users-dialog.component.html',
	providers: [ConfirmationService]
})

export class ImportFinalUsersDialogComponent implements OnInit, OnDestroy {

	deviceId: number;

	importing: boolean;
	importing$: Observable<boolean | undefined>;
	importingSub: Subscription;

	imported: boolean;
	imported$: Observable<boolean | undefined>;
	importedSub: Subscription;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	finalUsersLists: FinalUsersList;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	// Design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private translate: TranslateService,
		public confirmationService: ConfirmationService
	) {
		if (config.data !== undefined && config.data.finalUsersLists) {
			this.finalUsersLists = config.data.finalUsersLists;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		this.importing$ = this.store.select(selectImportingFinalUsers);
		this.imported$ = this.store.select(selectImportedFinalUsers);
		this.currentUser$ = this.store.select(selectUser);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	subscribeAll(): void {
		this.importingSub = this.importing$?.subscribe(
			(importing) => {
				this.importing = importing;
			}
		);
		this.importedSub = this.imported$?.subscribe(
			(imported) => {
				if (imported) {
					this.closeDialog();
				}
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
	}

	closeDialog(): void {
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.importingSub?.unsubscribe();
		this.importedSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	submitOverwrite(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('IMPORT_OVERWRITE'),
			message: this.translate.instant('IMPORT_OVERWRITE_FINAL_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				if (this.isImpersMode) {
					this.store.dispatch(UserFileActions.deleteFinalUsers({ userId: this.currentUser.Id }));
					this.store.dispatch(UserFileActions.importFinalUsersList({ importList: this.finalUsersLists, userId: this.currentUser.Id }));
				} else {
					this.store.dispatch(UserFileActions.deleteFinalUsers({}));
					this.store.dispatch(UserFileActions.importFinalUsersList({ importList: this.finalUsersLists }));
				}
			},
			reject: () => {
			}
		});
	}

	submitAdding(): void {
		if (this.isImpersMode) {
			this.store.dispatch(UserFileActions.importFinalUsersList({ importList: this.finalUsersLists, userId: this.currentUser.Id }));
		} else {
			this.store.dispatch(UserFileActions.importFinalUsersList({ importList: this.finalUsersLists }));
		}
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
